import { FC } from 'react';
import { LegalPageContent } from '../components';
import { LegalProps } from '../legal.type';
import { LegalWrapper } from '../provider';

export const TermsAndConditions: FC<LegalProps> = (props) => {
  return (
    <LegalWrapper {...props} documentType='terms-and-conditions'>
      <LegalPageContent />
    </LegalWrapper>
  );
};
